import { useQuery } from '@tanstack/react-query'

import { ClientBenefitConsumptionRecordsService } from '../services/client_benefit_consumption_records.service'
import { SortOrder } from '../types/general'
import { defaultQueryOptions } from './common'

export const useClientInvoiceFilterDates = (locationName: string, membershipId: string) => {
  return useQuery({
    queryKey: ['clientInvoiceFilterDates', locationName, membershipId],
    queryFn: async () => {
      const [firstRecord, lastRecord] = await Promise.all([
        ClientBenefitConsumptionRecordsService.get(locationName, membershipId, {
          sortOrder: SortOrder.ASC,
          limit: 1,
        }),
        ClientBenefitConsumptionRecordsService.get(locationName, membershipId, {
          sortOrder: SortOrder.DESC,
          limit: 1,
        }),
      ])

      return {
        startDate: firstRecord?.results[0]?.invoiceStartDate || '',
        endDate: lastRecord?.results[0]?.invoiceStartDate || '',
      }
    },
    enabled: !!locationName && !!membershipId,
    ...defaultQueryOptions,
  })
}
